import moment from 'moment';
import { Fragment, useState } from 'react';
import {
  Button,
  Col,
  Dropdown,
  Form,
  Row,
  SplitButton,
  Stack,
} from 'react-bootstrap';
import Select from 'react-select';
import PrimaryDatePicker from '../../../components/PrimaryDatePicker';
import { breakdownOptions, defaultForm, frequencyOptions } from '../const';

const Filter = ({ onFilter, onExport }) => {
  const [form, setForm] = useState(defaultForm);

  const handleBreakdownChange = (selected) => {
    setForm({ ...form, breakdown: selected.map((row) => row.value) });
  };

  const handleGenerate = () => {
    onFilter(form);
  };

  const handleExport = (type) => {
    onExport(type);
  };

  return (
    <Fragment>
      <Row>
        <Col lg="3">
          <Form.Group className="mb-3">
            <Form.Label>Period Breakdown</Form.Label>
            <Select
              name="frequency"
              options={frequencyOptions}
              value={
                form.frequency
                  ? frequencyOptions.find((row) => row.value === form.frequency)
                  : ''
              }
              onChange={(e) => setForm({ ...form, frequency: e.value })}
            />
          </Form.Group>
        </Col>
        <Col lg="3">
          <Stack gap={3} direction="horizontal">
            <Form.Group className="mb-3">
              <Form.Label>Date Range</Form.Label>
              <PrimaryDatePicker
                value={form.date_from}
                onChange={(date) => setForm({ ...form, date_from: date })}
                name={'date_from'}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>&nbsp;</Form.Label>
              <PrimaryDatePicker
                value={form.date_to}
                onChange={(date) => setForm({ ...form, date_to: date })}
                name={'date_to'}
              />
            </Form.Group>
          </Stack>
        </Col>
        <Col lg="4">
          <Form.Group className="mb-3">
            <Form.Label>Breakdown</Form.Label>
            <Select
              isMulti
              options={breakdownOptions}
              value={breakdownOptions.filter(
                (row) => form.breakdown.indexOf(row.value) !== -1,
              )}
              onChange={handleBreakdownChange}
            />
          </Form.Group>
        </Col>
        <Col lg="2">
          <Form.Group>
            <Form.Label>&nbsp;</Form.Label>
            <Button variant="success" onClick={handleGenerate}>
              Generate
            </Button>

            <SplitButton
              id="export-balance-sheet"
              variant="info"
              title="Export"
              className="float-right"
              onClick={() => handleExport('excel')}
            >
              <Dropdown.Item eventKey="1" onClick={() => handleExport('pdf')}>
                Export As PDF
              </Dropdown.Item>
            </SplitButton>
          </Form.Group>
        </Col>
      </Row>
    </Fragment>
  );
};

export default Filter;
